{
  "translation": {
    "button": {
      "ok": "Ok",
      "back": "Der Rücken",
      "create": "Schaffen",
      "logout": "Ausloggen",
      "login": "Anmeldung",
      "cancel": "Absagen",
      "search": "Suche..",
      "configurations": "Konfigurationen"
    },
    "label": {
      "configurationId": "Konfigurations-ID",
      "id": "Id",
      "product": "Produkt",
      "productName": "Produktname",
      "productId": "Produkt ID",
      "timeStamp": "Erstellt am",
      "modifiedOn": "Geändert am",
      "validate": "Bestätigen",
      "view": "Aussicht",
      "featureCode": "Funktionscode",
      "optionCode": "Optionscode",
      "productImages": "Produktbilder",
      "salesText": "Verkaufstext",
      "country": "Land",
      "createdOn": "Erstellt am",
      "timeZone": " UTC",
      "inActiveProduct": "Inaktives Produkt",
      "propertyCode": "Eigenschaftscode",
      "oldValue": "Alter Wert",
      "newValue": "Neuer Wert",
      "properties": "Eigenschaften",
      "options": "Optionen",
      "noRows": "Keine Zeilen",
      "no": "NEIN",
      "yes": "Zustimmen"
    },
    "tooltip": {
      "validate": "Bestätigen",
      "view": "Aussicht",
      "productInfo": "Produktinformation",
      "home": "Heim",
      "valid": "Gültig",
      "invalid": "Ungültig",
      "added": "Hinzugefügt",
      "deleted": "Gelöscht",
      "modified": "Geändert"
    },
    "actionTypes": {
      "created": "Erstellt",
      "cloned": "Geklont",
      "search": "Gesucht",
      "validate": "Bestätigt"
    },
    "pageErrors": {
      "noPageFound": "Keine Seite gefunden",
      "unauthenticated": "Benutzer ist nicht angemeldet. Bitte melden Sie sich an. Wenn das Problem weiterhin besteht, wenden Sie sich bitte an Ihren Administrator."
    },
    "message": {
      "logoutMessage": "Der Benutzer ist abgemeldet. Bitte melden Sie sich erneut zur Anwendung an.",
      "viewChange": "Möchten Sie die Ansicht ändern {{view}}?",
      "configurationExists": "Konfiguration existiert bereits",
      "loading": "Lädt...",
      "success": {
        "general": "Erfolg: ",
        "default": "Daten abgerufen",
        "getUser": "Benutzerdetails abgerufen",
        "searchConfiguration": "Konfiguration hinzugefügt",
        "getConfiguration": "Konfiguration abgerufen"
      },
      "error": {
        "401": "Sitzung abgelaufen. Bitte melden Sie sich erneut an.",
        "403": "Sie haben keinen Zugriff. Bitte wenden Sie sich an den Administrator.",
        "general": "Fehler: ",
        "default": "Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.",
        "getUser": "Benutzer konnte nicht geladen werden",
        "searchConfiguration": "Hinzufügen der Konfiguration fehlgeschlagen",
        "getConfiguration": "Konfiguration",
        "getDiff": "Unterschied konnte nicht geladen werden",
        "invalidConfiguration": "Ungültige Konfigurations-ID"
      }
    },
    "title": {
      "name": "Anwendung zur Konfigurationsvalidierung"
    },
    "footer": {
      "env": "Umschl",
      "termsAndConditions": "Terms und Bedingungen",
      "release": "R",
      "sprint": "SP",
      "build": "Bauen",
      "branch": "Zweig",
      "date": "Datum"
    }
  }
}